import script from "./ProjectRecycle.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectRecycle.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__